import ShowMoreText, { ShowMoreTextProps } from './ShowMoreText';

export default ShowMoreText;
export type { ShowMoreTextProps };
